/* tslint:disable */
/* eslint-disable */
/**
 * Thynk Direct API
 * The API for managing reservation for [Thynk Direct](https://thynk.cloud/).
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Remarks added to a reservation created by the client, the system or by a Partner employee.
 * @export
 * @interface ReservationRemarkWrite
 */
export interface ReservationRemarkWrite {
  /**
   * the database identifier of reservation remark
   * @type {number}
   * @memberof ReservationRemarkWrite
   */
  id?: number;
  /**
   * type of remark (internal, external or something like a diet request)
   * @type {string}
   * @memberof ReservationRemarkWrite
   */
  type?: ReservationRemarkWriteTypeEnum;
  /**
   * the actual remark a user made
   * @type {string}
   * @memberof ReservationRemarkWrite
   */
  description: string;
  /**
   * the reservation which this remarks belongs to
   * @type {string}
   * @memberof ReservationRemarkWrite
   */
  reservation: string;
  /**
   * sets the remark for a specific (reservation) day
   * @type {string}
   * @memberof ReservationRemarkWrite
   */
  reservationDay?: string | null;
}

export const ReservationRemarkWriteTypeEnum = {
  Internal: 'internal',
  External: 'external',
  Scribble: 'scribble',
  Tagtog: 'tagtog',
  Flag: 'flag',
  Note: 'note',
  DinnerRequest: 'dinner_request',
  DietaryRequirements: 'dietary_requirements',
  BreakfastRequest: 'breakfast_request',
} as const;

export type ReservationRemarkWriteTypeEnum =
  (typeof ReservationRemarkWriteTypeEnum)[keyof typeof ReservationRemarkWriteTypeEnum];
